import { render, staticRenderFns } from "./LongTermPayment.vue?vue&type=template&id=6507578e&"
import script from "./LongTermPayment.vue?vue&type=script&lang=js&"
export * from "./LongTermPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports